import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage';
import WorkshopLanding from './components/WorkshopLanding';
import WorkshopSetup from './components/WorkshopSetup';
import './App.css';

function App() {
  useEffect(() => {
    if (window.lucide) {
      window.lucide.createIcons();
    }
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Paso 1: Tu landing actual de Desarrollo RD */}
          <Route path="/" element={<LandingPage />} />

          {/* Paso 2: La landing dinámica para los nuevos talleres */}
          {/* El ":slug" es la clave; React leerá lo que escribas ahí */}
          <Route path="/taller/:slug" element={<WorkshopLanding />} />
          <Route path="/setup/:workshopId" element={<WorkshopSetup />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;